import _ from "lodash";
import React from "react";
import { Button, Modal, RadioButton } from "@toddle-edu/ds-web";
import { useI18n } from "Hooks";
import {
  ADD_MEMBERS_OPTION_LIST,
  KEYBOARD_SHORTCUT,
} from "MessagingV2/modules/Utils";
import classes from "./AddMemberOrCreateChannelOptionModal.scss";
import classNames from "classnames";

const AddMemberOrCreateChannelOptionModal = props => {
  const { onClose, onClickNext, selectedOption, onSelectOption } = props;

  const { t } = useI18n(["common"]);

  return (
    <Modal
      height="max-content"
      width="480px"
      hasOverlay
      shouldCloseOnEsc
      shouldCloseOnOverlayClick
      onClose={onClose}
      isOpen
      dsVersion="2.0"
      footerSeparator
    >
      <Modal.Header
        isClosable
        hasSeparator
        title={t("common:old_to_new_channel_modal_title")}
      />
      <Modal.Body>
        <div className={classes.optionContainer}>
          {_.map(ADD_MEMBERS_OPTION_LIST, ({ label, subText, value }) => {
            const isChecked = _.isEqual(selectedOption, value);

            return (
              <div className={classes.optionItem} key={value}>
                <div className={classes.optionRadioButton}>
                  <RadioButton
                    checked={isChecked}
                    dsVersion="2.0"
                    onClick={() => onSelectOption(value)}
                  />
                </div>
                <div className={classes.optionRadioButtonText}>
                  <div className={"text-body-l"}>{t(label)}</div>
                  <div
                    className={classNames(
                      "text-body",
                      classes.optionRadioButtonSubtext
                    )}
                  >
                    {t(subText)}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </Modal.Body>
      <Modal.Footer hasSeparator>
        <div className={classes.footerContainer}>
          <Button
            variant="neutral"
            type="outlined"
            onClick={onClose}
            dsVersion="2.0"
          >
            {t("common:cancel")}
          </Button>
          <Button
            variant="progressive"
            onClick={onClickNext}
            dsVersion="2.0"
            shortcut={KEYBOARD_SHORTCUT.SHIFT_ENTER}
          >
            {t("common:next")}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default AddMemberOrCreateChannelOptionModal;
